import {
  IKeyValuePairT,
  TTransactionPeriodSelect,
} from "../interfaces-and-types";

interface IFilterConstants {
  // keys
  transactionPeriodKey: string;
  monthlyOrYearlyStatusKey: string;
  currentPageKey: string;
  pageSizeKey: string;
  searchKey: string;
  statusKey: string;
  // fraudStatusKey: string;

  // options
  transactionPeriods: IKeyValuePairT<TTransactionPeriodSelect>[];
}

export const filterConstants: IFilterConstants = {
  // keys
  transactionPeriodKey: "txpd",
  monthlyOrYearlyStatusKey: "mnthoryr",
  currentPageKey: "pgsz",
  pageSizeKey: "pg",
  searchKey: "search",
  statusKey: "status",
  // fraudStatusKey: "fraudstat",

  // options
  transactionPeriods: [
    { key: "7 days", value: "7d" },
    { key: "1 month", value: "1m" },
    { key: "6 months", value: "6m" },
  ],
};
